import React from 'react';
import Loader from '../components/theme/Loader';
import AdminTabs from "../components/admin/AdminTabs";
import { useUserRole } from '../auth/useUserRole.ts';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

function AdminPage() {
    const { isSignedIn, isLoaded } = useAuth();
    const role = useUserRole();

    if (!isLoaded || role === null) return <Loader />;
    if (!isSignedIn || role !== 'admin') return <Navigate to="/" replace={true} />;

    return <AdminTabs />;
}

export default AdminPage;
